module.exports = __webpack_public_path__ + "img/Veranza-22-min.c472810c.jpg";